/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PreseasonGameMessageDto } from './PreseasonGameMessageDto';
export type PreseasonGameDetailsDto = {
    id?: number;
    sportsClubCreatorId?: number;
    sportsClubCreatorName?: string;
    teamCreatorId?: number;
    teamCreatorName?: string;
    teamCreatorTier?: string;
    sportsClubOpponentId?: number;
    sportsClubOpponentName?: string;
    teamOpponentId?: number;
    teamOpponentName?: string;
    teamOpponentTier?: string;
    /**
     * Date in ISO8601 format (yyyy-MM-dd). Accepts string from frontend.
     */
    date?: string;
    /**
     * Start time in ISO8601 format (HH:mm). Accepts string from frontend.
     */
    startTime?: string;
    /**
     * End time in ISO8601 format (HH:mm). Accepts string from frontend.
     */
    endTime?: string;
    /**
     * Changed date in ISO8601 format (yyyy-MM-dd). Accepts string from frontend.
     */
    changedDate?: string;
    /**
     * Changed start time in ISO8601 format (HH:mm). Accepts string from frontend.
     */
    changedStartTime?: string;
    /**
     * Changed end time in ISO8601 format (HH:mm). Accepts string from frontend.
     */
    changedEndTime?: string;
    changeRequesterTeamId?: number;
    hasPitchAvailable?: boolean;
    location?: string;
    status?: PreseasonGameDetailsDto.status;
    pendingStatus?: PreseasonGameDetailsDto.pendingStatus;
    messages?: Array<PreseasonGameMessageDto>;
    createdAt?: string;
    cancelledByTeamId?: number;
    cancellationReason?: string;
    cancelledAt?: string;
    manualOpponent?: boolean;
    manualOpponentName?: string;
    hasOtherGamesInSchedule?: boolean;
};
export namespace PreseasonGameDetailsDto {
    export enum status {
        PENDING = 'PENDING',
        CONFIRMED = 'CONFIRMED',
        CONFIRMED_WITH_TIME_TO_CONFIRM = 'CONFIRMED_WITH_TIME_TO_CONFIRM',
        PENDING_WITH_DATE_TIME_CHANGE_ORIGINAL = 'PENDING_WITH_DATE_TIME_CHANGE_ORIGINAL',
        PENDING_WITH_DATE_TIME_CHANGE_TARGET = 'PENDING_WITH_DATE_TIME_CHANGE_TARGET',
        BLOCKED = 'BLOCKED',
        WARNING = 'WARNING',
        CANCELLED = 'CANCELLED',
    }
    export enum pendingStatus {
        PENDING_WITHOUT_TIME = 'PENDING_WITHOUT_TIME',
        PENDING_WITH_TIME = 'PENDING_WITH_TIME',
        PENDING_WITH_DATE_TIME_CHANGE = 'PENDING_WITH_DATE_TIME_CHANGE',
    }
}

